import { X } from "lucide-react";

export default function Popup({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1111] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      
      <div className="relative bg-white rounded-xl shadow-xl max-w-5xl w-[95%] max-h-[90vh] overflow-auto p-6">

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-600 hover:text-black"
        >
          <X size={20} />
        </button>

        {children}

      </div>
    </div>
  );
}